var map = {
	"./air-nga-en/assets/question-icon.png": 48270,
	"./ais-tai-en/assets/question-icon.png": 78995,
	"./ais-tai-tha/assets/question-icon.png": 73359,
	"./demo-arabic/assets/question-icon.png": 85639,
	"./demo-et-en/assets/question-icon.png": 48178,
	"./demo-romanian/assets/question-icon.png": 3400,
	"./demo-um-en/assets/question-icon.png": 69255,
	"./dtac-tai-en/assets/question-icon.png": 37032,
	"./dtac-tai-tha/assets/question-icon.png": 34406,
	"./ethiotel-et-amh/assets/question-icon.png": 3252,
	"./ethiotel-et-en/assets/question-icon.png": 50293,
	"./mtn-cg-fr/assets/question-icon.png": 89404,
	"./mtn-ci-fr/assets/question-icon.png": 65846,
	"./mtn-cmr-fr/assets/question-icon.png": 35066,
	"./mtn-gha-en/assets/question-icon.png": 6493,
	"./mtn-nga-en/assets/question-icon.png": 22049,
	"./mtn-zam-en/assets/question-icon.png": 89799,
	"./saf-ke-en/assets/question-icon.png": 60714,
	"./saudi-uae-en/assets/question-icon.png": 21847,
	"./tlk-za-en/assets/question-icon.png": 9006,
	"./vc-za-en/assets/question-icon.png": 77402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10130;